<template>
  <v-row>
    <!-- Cron email -->
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Cron Notification Email
        </gg-card-header>
        <gg-card-text>
          <p>
            Send an email with the output every time the cron job runs. You can have cron send an email every time
            it runs a command which produces output. If you do not want an email to be sent for an individual cron job,
            you can redirect the command’s output to /dev/null. For example: <code>mycommand >/dev/null 2>&1</code>
          </p>
          <cron-email-form v-if="!isLoadingEmail && accountUser" :account-user="accountUser"/>
          <v-progress-linear v-else indeterminate color="green" height="4"></v-progress-linear>
        </gg-card-text>
      </gg-card>
    </v-col>

    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Add New Cron Job
        </gg-card-header>
        <gg-card-text>
          <p>PHP command examples:</p>
          <p>
            General example:
            <code>/usr/local/bin/php /home/{{ accountUser }}/public_html/path/to/cron/script</code>
          </p>
          <cron-job-form @job-added="reloadTable"/>
        </gg-card-text>
      </gg-card>
    </v-col>

    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Manage Cron Jobs
        </gg-card-header>
        <gg-card-text>
          <cron-jobs-table
            @table-reloaded="tableReloaded"
            :table-should-be-reloaded="tableShouldBeReloaded"
          />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CronEmailForm from '@/components/Services/Hosting/Shared/Cron/CronEmailForm'
import CronJobForm from '@/components/Services/Hosting/Shared/Cron/CronJobForm'
import CronJobsTable from '@/components/Services/Hosting/Shared/Cron/CronJobsTable'

export default {
  name: 'CronJobsView',
  components: {
    CronEmailForm,
    CronJobForm,
    CronJobsTable,
  },
  data () {
    return {
      isLoadingEmail: true,
      cronEmail: null,
      tableShouldBeReloaded: false,
    }
  },
  computed: {
    ...mapGetters(['hosting_detail']),
    accountUser () {
      return this.hosting_detail ? this.hosting_detail?.accountsummary?.user : null
    },
  },
  methods: {
    ...mapActions(['getCronEmail', 'reportError', 'getHostingDetail']),
    reloadTable () {
      this.tableShouldBeReloaded = true
    },
    tableReloaded () {
      this.tableShouldBeReloaded = false
    }
  },
  created () {
    this.getHostingDetail(this.$route.query.user)
    this.getCronEmail({ _username: this.$route.query.user })
      .then(email => {
        this.cronEmail = email
        this.isLoadingEmail = false
      }).catch(error => {
        this.reportError(error)
      })
  }
}
</script>
